import axios from 'axios';

const BASE_URL = 'https://api.tcsxxjd.com';
const isLocalAdminPreview = typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
const ACTIVE_BASE_URL = isLocalAdminPreview ? 'http://127.0.0.1:4444' : BASE_URL;

// 登录请求方法
const loginreq = (method, url, params) => {

    let text = "";
    let a = 0;
    for (const key in params) {
      
      
      if(a==0){
        text =text+ key+"="+params[key]
      }else{
        text =text+ "&"+key+"="+params[key]
      }
      a++;
    }

    return axios({
        method: method,
        // url: "http://82.156.19.188:6704"+url+"?"+text,
        // url: "https://jz.youkutongcheng.com/"+url+"?"+text,
        url: ACTIVE_BASE_URL + url + "?" + text,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                
                return ret
            }
        ]
    }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
    const token = localStorage.getItem('logintoken');
    return axios({
        method: method,
        url: ACTIVE_BASE_URL + url,
        params: Object.assign({}, params, { token: token }),
        // url: "http://82.156.19.188:6704"+url+"?"+text+"&token="+localStorage.getItem('logintoken'),
        // url: "https://jz.youkutongcheng.com/"+url+"?"+text+"&token="+localStorage.getItem('logintoken'),
        
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: token,

        },
        traditional: true
    }).then(res => res.data);
};
// 通用公用方法
const reqPost = ( url, params) => {
    params.token = localStorage.getItem('logintoken');
    return axios({
        method: "post",
        // url: "http://82.156.19.188:6704"+url,

        url: ACTIVE_BASE_URL + url,
        
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('logintoken'),
            
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }

                return ret
            }
        ]
    }).then(res => res.data);
};

 

export {
    loginreq,
    req,
    reqPost,
   
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js